<div *ngIf="imageUrl" class="logo-wrapper">
  <img [src]="imageUrl" [alt]="imageAlt" class="logo" />
</div>
